import { createContext, useState } from "react";
export const ContextData = createContext({});
